module.exports = __webpack_public_path__ + "static/media/total-applications.97a47ee0.svg";